import { Header } from './components/layout/Header'
import { Hero } from './components/sections/Hero'
import { LearningLoop } from './components/sections/LearningLoop'
import { Xiaozhi } from './components/sections/Xiaozhi'
import { Features } from './components/sections/Features'
import { ParentsNote } from './components/sections/ParentsNote'
import { PlatformCTA } from './components/sections/PlatformCTA'
import { Footer } from './components/layout/Footer'
import { DownloadPage } from './components/pages/DownloadPage'

function HomePage() {
  return (
    <div className="min-h-screen bg-canvas text-ink">
      <Header />
      <main>
        <Hero />
        <LearningLoop />
        <Xiaozhi />
        <Features />
        <ParentsNote />
        <PlatformCTA />
      </main>
      <Footer />
    </div>
  )
}

function App() {
  // 极简路径分发（无 react-router 依赖）：下载页路径，其余渲染首页。
  // 法务页（/privacy /terms）由 nginx 直出静态 html（public/legal/），不进 SPA。
  const path = window.location.pathname.replace(/\/+$/, '') || '/'
  if (path === '/download' || path === '/landing/download') return <DownloadPage />
  return <HomePage />
}

export default App
